import { render, staticRenderFns } from "./Details2ProductMobile.vue?vue&type=template&id=68309372&scoped=true"
import script from "./Details2ProductMobile.vue?vue&type=script&lang=js"
export * from "./Details2ProductMobile.vue?vue&type=script&lang=js"
import style0 from "./Details2ProductMobile.vue?vue&type=style&index=0&id=68309372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68309372",
  null
  
)

export default component.exports